import { helperOrganizersStore } from 'stores';

export const getOrganizer = (organizerId: number) => helperOrganizersStore.values.find((organizer) => organizer.id === organizerId);
